<script>
import { nlToBr } from '@utils'

export default {
  filters: {
    nlToBr,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    selectQty: {
      type: Number,
      default: 0,
    },
    maxQty: {
      type: Number,
      required: true,
    },
    payMethodType: {
      type: String,
      default: '',
    },
  },
  methods: {
    onInput(value) {
      this.$emit('change', value)
    },
  },
}
</script>

<template>
  <div :class="$style.wrapper" :data-max="maxQty">
    <div :class="$style.column">
      <div :class="$style.column">
        <div :class="$style.title">{{ data.name }}</div>
        <div :class="$style.subtitle">{{ data.introtext }}</div>
      </div>
      <div
        :class="$style.column"
        class="is-text-content"
        v-html="$options.filters.nlToBr(data.description)"
      ></div>
      <div v-if="payMethodType === 'prepaid'" :class="[$style.column, $style.price]">
        {{ $t('global.TOTAL_DEDUCT', { size: data.size } /* 抵用 {size} 次 */) }}
      </div>
      <div v-else :class="[$style.column, $style.price]">
        <span v-if="data.price === 0">{{$t('global.FREE')}}</span>
        <span v-else>
          <span
            v-if="data.basePrice > data.price"
            class="has-text-grey-light"
            style="margin-bottom: 0.25rem;text-decoration: line-through;"
          >
            ${{ data.basePrice }}
          </span>
          <br>${{ data.price }}
        </span>
      </div>
    </div>
    <div :class="$style.column">
      <b-numberinput
        :value="selectQty"
        :max="maxQty"
        :editable="false"
        min="0"
        type="is-primary"
        controls-position="compact"
        expanded
        :class="{ 'is-zero': selectQty === 0 }"
        @input="onInput"
      ></b-numberinput>
    </div>
  </div>
</template>

<style lang="scss" module>

.wrapper {
  display: flex;
  align-items: center;
  @include mobile {
    flex-direction: column;
    padding-bottom: 1rem;
    align-items: stretch;
  }
  &:not(:last-child) {
    border-bottom: 1px solid $color-border-base;
  }

  .column {
    padding: 0.75rem 0;
    @include tablet {
      &:not(:first-child) {
        padding-left: 0.75rem;
      }
    }
    @include mobile {
      padding: 0.5rem 0;
    }
  }

  > .column {
    &:first-child {
      flex: 3;
      display: flex;
      align-items: center;
      @include mobile {
        flex: 2;
        flex-direction: column;
        align-items: flex-start;
        padding-right: 0.5rem;
      }
      > .column {
        flex: 1;
      }
    }
    &:last-child {
      flex: 1;
    }
  }
  .title {
    @extend %typography-medium;
    margin-bottom: 0.4rem;
    color: $color-text-primary;
  }
  .subtitle {
    @extend %typography-small;
    color: $color-text-regular;
  }
  .price {
    font-weight: 500;
    text-align: center;
  }
}
</style>
